import { Helmet } from "react-helmet-async";

const SeoHead = () => {
  const cacheBust = "?v=3";

  return (
    <Helmet>
      <link rel="icon" href={`/favicon.ico${cacheBust}`} type="image/x-icon" />
      <link rel="icon" href={`/favicon.png${cacheBust}`} type="image/png" />
      <link rel="apple-touch-icon" href={`/apple-touch-icon.png${cacheBust}`} />
    </Helmet>
  );
};

export default SeoHead;
